import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppSettingsService } from "./../shared/services/app-settings.service";
import { ViewStateService } from "../shared/services/view-state.service";
import moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit, OnDestroy {
  contactLink: string;
  privacyLink: string;
  termsLink: string;
  isAssessment: boolean;
  currentYear: string;
  private destroy$ = new Subject<void>();

  constructor(
    private appSettings: AppSettingsService,
    private viewState: ViewStateService
  ) {
    this.contactLink = this.appSettings.ExternalLinks.contactUs;
    this.privacyLink = this.appSettings.ExternalLinks.privacyPolicy;
    this.termsLink = this.appSettings.ExternalLinks.termsOfUse;
    this.viewState.state$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.isAssessment = state.isAssessment;
    });
  }

  ngOnInit() {
    this.currentYear = moment(new Date()).format("YYYY");
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
